import { useSubscription } from './useSubscription';

type Tier = 'basic' | 'premium' | 'enterprise' | null;

interface FeatureAccess {
  hasContactsAccess: boolean;
  hasReservationsAccess: boolean;
  hasCateringAccess: boolean;
  tier: Tier;
}

export const useFeatureAccess = (): FeatureAccess => {
  const { tier } = useSubscription();

  const hasContactsAccess = tier === 'basic' || tier === 'premium' || tier === 'enterprise';
  const hasReservationsAccess = tier === 'premium' || tier === 'enterprise';
  const hasCateringAccess = tier === 'enterprise';

  return {
    hasContactsAccess,
    hasReservationsAccess,
    hasCateringAccess,
    tier,
  };
};
